import { Component, OnInit } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CommonModule } from '@angular/common';
import { AddProjectsService } from '../add-projects.service';
import { FormBuilder, FormGroup, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from 'src/app/shared/spinner/spinner.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EditorModule } from "@tinymce/tinymce-angular";
import { NavbarComponent } from '../../../components/navbar/navbar.component';

@Component({
  selector: 'app-add-projects',
  standalone: true,
  imports: [CommonModule, SpinnerComponent,EditorModule, NavbarComponent, MatSnackBarModule, FormsModule, ReactiveFormsModule],
  templateUrl: './add-projects.component.html',
  styleUrls: ['./add-projects.component.scss'],
  providers: [AddProjectsService]
})
export class AddProjectsComponent implements OnInit {
  fGroup: FormGroup
  isLoading = false;
  project: any;
  idDetail: any;
  detailData: any;
  typeEdit: any;
  constructor(private addProjectService: AddProjectsService, private _snackBar: MatSnackBar, private fb: FormBuilder, private router: Router) {
    this.fGroup = this.fb.group({
      name: [''],
      description: [''],
      imageLink: [''],
      linkVideo: [''],
      status: ['']
    })
  }

  ngOnInit(): void {
    // this.getProject();
    this.idDetail = history.state.value.id;
    this.typeEdit = history.state.value.type;
    console.log(this.idDetail);
    this.doGetById();
  }


  // getProject(){
  //   this.addProjectService.getProject().subscribe((value: any) => {
  //     this.project = value;
  //     this.isLoading = false;
  //     console.log(this.project);
  //   })
  // }
  doAddProject(){
    this.isLoading = true;
    if(this.typeEdit == 'edit'){
      console.log('ini edit')
      this.addProjectService.editProject(this.idDetail, this.fGroup.value).subscribe((value: any) => {
        this.isLoading = false
      this._snackBar.open(value.message);

          this.router.navigate([''])
        console.log(value, 'edit success');
      }, error => {
        this._snackBar.open(error.message);
      });

    }else{
      this.isLoading = true;
      this.addProjectService.postProject(this.fGroup.value).subscribe((value: any)=> {
        this.isLoading = false;
        this._snackBar.open(value.message);
        this.router.navigate([''])
        console.log(value);
      }, error => {
      this._snackBar.open(error.error.message);
      })
    }

  }

  doGetById(){
    this.addProjectService.getById(this.idDetail).subscribe((value: any) => {
      console.log(value);
      this.detailData = value.data;
      this.fGroup.setValue({
        name: this.detailData.name,
        description: this.detailData.description,
        imageLink: this.detailData.imageLink,
        linkVideo: this.detailData.linkVideo,
        status: this.detailData.status,
      })
    } )
  }

  doDeleteProject(){
    this.addProjectService.deleteProject(this.idDetail).subscribe((value: any) => {
      console.log(value)
      this._snackBar.open(value);
    }, error => {
      this._snackBar.open(error.error.message);
    })
  }

}
